import api from './client';

export interface CallParams {
  page?: number;
  limit?: number;
  status?: string;
  agent_id?: string;
  date_from?: string;
  date_to?: string;
}

export async function getCalls(params?: CallParams) {
  const { data } = await api.get('/api/v1/calls', { params });
  return data;
}

export async function getCall(id: string) {
  const { data } = await api.get(`/api/v1/calls/${id}`);
  return data;
}

export async function createCall(callData: { agent_id: string; to_number: string }) {
  const { data } = await api.post('/api/v1/calls', callData);
  return data;
}

export async function endCall(id: string) {
  const { data } = await api.post(`/api/v1/calls/${id}/end`);
  return data;
}
